var map = {
	"./bg.json": "dcd0",
	"./cs.json": "c686",
	"./da.json": "21aa",
	"./de.json": "6ce2",
	"./el.json": "f184",
	"./en copy.json": "b662",
	"./en.json": "edd4",
	"./es.json": "a306",
	"./et.json": "e1db",
	"./fi.json": "5754",
	"./fr.json": "f693",
	"./hr.json": "92d7",
	"./hu.json": "4e73",
	"./it.json": "0825",
	"./lt.json": "6045",
	"./lv.json": "f620",
	"./mt.json": "31f2",
	"./nl.json": "a625",
	"./pl.json": "89b2",
	"./pt.json": "5d67",
	"./ro.json": "9542",
	"./sk.json": "3da9",
	"./sl.json": "d34a",
	"./sv.json": "4c5b",
	"./tr.json": "ffeb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";